var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 40,
    viewBox: "0 0 150 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1361 29.0186H43.0469V39.0687H55.7667V33.9983H48.1361V29.0186Z",
    fill: "#0D6CF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1873 19.9383H37.5502V15.0297H45.1873V0.0644531H32.4609V5.13478H40.098V10.0693H32.4609V25.0087H45.1873V19.9383Z",
    fill: "#0D6CF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1117 12.9014H18.7468C17.6345 8.90463 13.9615 5.95556 9.60295 5.93615V10.211C10.7605 10.2239 10.4759 12.5004 11.4265 13.1795C12.3771 13.8521 14.4659 12.882 14.8345 13.9944C15.1772 15.0809 12.9139 15.5336 12.5517 16.6395C12.209 17.7518 13.7804 19.4269 12.8298 20.1059C11.8792 20.7785 10.7669 18.7737 9.60295 18.7672V24.924C13.9615 24.8982 17.6345 21.9556 18.7468 17.9523H23.1117V24.924H28.8476V5.92969H23.1117V12.8949V12.9014ZM9.60295 5.92969H9.55122C4.29384 5.92969 0 10.1851 0 15.4107C0 20.6362 4.28738 24.9176 9.55122 24.9176H9.60295V18.7607H9.59648C8.43249 18.7607 7.30729 20.7785 6.36317 20.0995C5.43197 19.4204 6.99043 17.7454 6.64123 16.633C6.27263 15.5206 4.00931 15.0744 4.37791 13.9879C4.72064 12.8755 6.83523 13.8521 7.75996 13.173C8.71055 12.494 8.42602 10.2045 9.59002 10.2045H9.59648V5.92969H9.60295Z",
    fill: "#0D6CF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1544 5.92969H50.4443V24.9176H56.1544V5.92969Z",
    fill: "#0D6CF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.515 5.9303V11.4275C129.714 11.4275 131.524 13.2124 131.524 15.4113C131.524 17.6102 129.714 19.4145 127.515 19.4145V24.9117C132.772 24.9117 137.066 20.6562 137.066 15.4048C137.066 10.1534 132.772 5.92383 127.515 5.92383V5.9303ZM127.515 5.9303C122.251 5.9303 117.964 10.1858 117.964 15.4113C117.964 20.6368 122.251 24.9182 127.515 24.9182V19.421C125.297 19.421 123.506 17.6102 123.506 15.4178C123.506 13.2254 125.297 11.4339 127.515 11.4339V5.93676V5.9303Z",
    fill: "#0D6CF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.425 14.713H111.848V9.64268H102.51V5.07033H111.848V0H97.4208V14.713H102.335V19.2854H95.332V24.3557H114.415V19.2854H107.425V14.713Z",
    fill: "#0D6CF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.992 39.9996C109.319 39.9996 112.849 36.7271 112.849 32.6916C112.849 28.656 109.319 25.403 104.992 25.3965V29.8072C106.693 29.8072 108.096 31.1006 108.096 32.6916C108.096 34.2825 106.693 35.5889 104.992 35.5889V39.9996ZM104.992 25.403C100.66 25.403 97.1289 28.6754 97.1289 32.698C97.1289 36.7207 100.66 40.006 104.992 40.006V35.5954C103.272 35.5954 101.888 34.2825 101.888 32.698C101.888 31.1135 103.162 29.8136 104.992 29.8136V25.403Z",
    fill: "#0D6CF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8735 5.9303V11.4275C72.0915 11.4275 73.8828 13.2124 73.8828 15.4113C73.8828 17.6102 72.0915 19.4145 69.8735 19.4145V24.9117C75.1309 24.9117 79.4247 20.6562 79.4247 15.4048C79.4247 10.1534 75.1309 5.92383 69.8735 5.92383V5.9303ZM69.8735 5.9303C64.6161 5.9303 60.3223 10.1858 60.3223 15.4113C60.3223 20.6368 64.6096 24.9182 69.8735 24.9182V19.421C67.6748 19.421 65.8642 17.6102 65.8642 15.4178C65.8642 13.2254 67.6748 11.4339 69.8735 11.4339V5.93676V5.9303Z",
    fill: "#0D6CF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.129 12.9014V5.92969H139.419V24.9176H145.129V17.9459H149.998V12.9014H145.129Z",
    fill: "#0D6CF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9205 5.92969H84.1846V24.9176H89.9205V5.92969Z",
    fill: "#0D6CF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.0b2a1ef0ee61a8c1c56181f4a4582d2b.svg";
export { ForwardRef as ReactComponent };